export const fetchQuestions = (state, questions) => {
  state.questions = questions;
}

const QuestionMutation = {
  fetchQuestions
};

export default QuestionMutation;
